<template>
    <li class="list-none my-0 border-t border-gray-400">
        <div class="bg-white">
            <a href="#"
                role="button"
                :aria-expanded="active ? 'true' : 'false'"
                :tabindex="tabbable === false ? '-1' : '0'"
                class="tab__link p-0 block no-underline text-gray-900 flex content-center items-center"
                @click.prevent="active = !active"
            >
                <div :class="['w-8 lg:w-12 h-8 lg:h-12 flex justify-center items-center content-center text-xl text-black font-bold font-mono', color]"
                >
                    {{ number }}
                </div>

                <span class="w-24 lg:w-auto font-bold px-3 text-xs lg:text-lg text-left border-r-2 border-gray-300">
                    {{ title }}
                </span>

                <span class="sr-only">:</span>

                <span class="md:flex-1 pl-3 text-xs lg:text-xs leading-tight">
                    {{ description }}
                </span>

                <span v-show="! active"
                    class="down-Arrow px-2 print:hidden"
                >
                    <i aria-hidden="true" class="material-icons hidden lg:inline-block">menu_book</i>
                    <i aria-hidden="true" class="material-icons">expand_more</i>
                </span>

                <span v-show="active"
                    class="up-Arrow px-2 text-block text-red-800"
                >
                    <i aria-hidden="true" class="material-icons text-gray-300 hidden lg:inline-block">menu_book</i>
                    <i aria-hidden="true" class="material-icons">cancel</i>
                </span>
            </a>
        </div>

        <div class="bg-white p-4 pl-10 lg:pl-16 relative border-t border-gray-400" v-show="active">
            <slot />
        </div>
    </li>
</template>

<script>
export default {
    props: {
        title: {},
        color: {},
        description: {},
        tabbable: {},
        number: {},
    },

    data() {
        return {
            active: false,
        }
    },
}
</script>
